export default {
  // Admin Endpoints
  adminLogsEndpoint: '/logs',
  adminAgentEndpoint: '/agents',
  adminClaimEndpoint: '/claims',
  adminsEndpoint: '/admin-users',
  adminSearchEndpoint: '/search',
  adminPatientsEndpoint: '/patients',
  adminDashboardEndpoint: '/dashboard',
  adminPatientFamilyEndpoint: '/family',
  adminNotificationsEndpoint: '/notifications',

  adminReportsRoute: '/reports',
  adminLabReportsRoute: 'reports/lab',
  adminICD10ReportsRoute: 'reports/icd-10',
  adminPharmacyReportsRoute: 'reports/pharmacy',
  adminMedicationReportsRoute: 'reports/medication',

  adminLabsRoute: '/labs',
  adminDrugRoute: '/drugs',
  adminGeoDataRoute: 'geo-data',
  adminAPIKeysRoute: '/api-keys',
  adminAuditTrail: '/audit-trail',
  adminLabTypesRoute: '/lab-types',
  adminDoctorNotes: '/doctor-notes',
  adminPoliciesEndpoint: '/policies',
  adminSettingsEndpoint: '/settings',
  adminPharmaciesRoute: '/pharmacies',
  adminLabUploadsRoute: '/lab-uploads',
  adminCancerTypesRoute: '/cancer-types',
  adminLabProfilesRoute: '/lab-profiles',
  adminAppointmentsRoute: '/appointments',
  adminConsultationRoute: '/consultations',
  adminExcuseDutiesRoute: "/excuse-duties",
  adminPermissionsEndpoint: '/permissions',
  adminAuscultationsRoute: '/auscultations',
  adminPrescriptionsRoute: '/prescriptions',
  adminLabRequestsEndpoint: '/lab-requests',
  adminLabCategoriesRoute: '/lab-categories',
  adminPatientDiagnosis: '/patient-diagnosis',
  adminPrescriptionsEndpoint: '/prescriptions',
  adminDieticianNotesRoute: '/dietician-notes',
  adminDirectQuestionsRoute: '/direct-questions',
  adminDietPlanUploadsRoute: '/diet-plan-uploads',
  adminPharmacyProfilesRoute: '/pharmacy-profiles',
  adminPreviousMedications: '/previous-medications',
  adminExternalReferralsRoute: "/external-referrals",
  adminCommonComplaintsEndpoint: '/common-complaints',
  adminPresentingQuestionsEndpoint: '/presenting-questions',
  adminPresentingComplaintsEndpoint: '/presenting-complaints',
  adminPrescriptionDeliveriesEndpoint: '/prescription-deliveries',
  adminICD10MedicalDiagnosisCodesEndpoint: '/icd-10-diagnosis-codes',
}
